// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import TerceraFontPickerTemplate from '@front/templates/TerceraFontPickerTemplate.html';
import { ContainerControl } from './ContainerControl';
export class TerceraFontPicker extends ContainerControl {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.FontChanged = new CustomEvent();
        this.observe('font', this.onFontChanged);
    }
    onFontChanged(newFont) {
        this.FontChanged.Raise(this, newFont);
    }
}
ContainerControl.extendWith(TerceraFontPicker, {
    data: function () {
        return {
            font: null,
            height: 20
        };
    },
    computed: {
        bold: {
            get: function () {
                const font = this.get('font');
                return font ? font.FontWeight === 'bold' : false;
            },
            set: function (bold) {
                if (this.get('font')) {
                    void this.set('font.FontWeight', bold ? 'bold' : '');
                }
            }
        }
    },
    template: TerceraFontPickerTemplate
});
